// extracted by mini-css-extract-plugin
module.exports = {"czechPointBtn":"czechPointBtn_czechPointBtn__1I07h"};